import { render, staticRenderFns } from "./CheckboxesCriterionInput.vue?vue&type=template&id=4c687d7c"
import script from "./CheckboxesCriterionInput.vue?vue&type=script&lang=ts"
export * from "./CheckboxesCriterionInput.vue?vue&type=script&lang=ts"
import style0 from "./CheckboxesCriterionInput.vue?vue&type=style&index=0&id=4c687d7c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports